import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ModalDirective } from 'ngx-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
import { environment } from '../../../../../../environments/environment';
import { EventsService } from '../../../../../services/events/events.service';
import { LoadingIndicatorService } from '../../../../../services/loading-indicator/loading-indicator.service';
import * as moment from 'moment';

@Component({
  selector: 'tripmakery-booking-payment-details-modal',
  templateUrl: './modal-booking-payment-details.component.html',
  styleUrls: ['./modal-booking-payment-details.component.css'],
})
export class ModalBookingPaymentDetailsComponent implements OnInit {
  public bookingId: string;
  public booking: any;
  public bookingLogs: any;
  public offer: any;
  public environment_;
  public formAddComment: FormGroup;
  public refundApprovalsLoading: { [key: string]: boolean } = {};

  @ViewChild('childModal') public childModal: ModalDirective;

  constructor(
    private http: HttpClient,
    private loadingIndicatorService: LoadingIndicatorService,
    private eventsService: EventsService
  ) {
    this.resetFormData();
    this.environment_ = environment;
  }

  ngOnInit() {
    this.eventsService.on(
      'requestShowModalBookingPaymentDetails',
      (bookingId) => {
        /* */
        this.booking = null;
        this.offer = null;
        this.bookingLogs = [];
        this.bookingId = bookingId;

        /* */
        this.resetFormData();
        this.loadBookingPaymentDetails();
        this.showChildModal();
      }
    );
  }

  private loadBookingPaymentDetails() {
    this.loadingIndicatorService.showLoadingBar();
    this.http
      .get(
        environment.urls.service +
          '/api/v1/authenticated/admin/booking/payments/' +
          this.bookingId
      )
      .subscribe(
        (response: any) => {
          /* */
          if (response.offer.cancellationPolicy.numberOfDays != null) {
            response.offer.cancellationPolicy.calculatedDate = moment
              .utc(response.offer.dates.from)
              .add(-response.offer.cancellationPolicy.numberOfDays, 'days')
              .format('YYYY-MM-DD');
          }

          /* */
          if (
            response.offer.cancellationPolicy.grading != null &&
            response.offer.cancellationPolicy.grading.length > 0
          ) {
            for (const grading of response.offer.cancellationPolicy.grading) {
              grading.calculatedDate = moment
                .utc(response.offer.dates.from)
                .add(-grading.daysBeforeArrival, 'days')
                .format('YYYY-MM-DD');
            }
          }

          if (
            response.offer.paymentPolicy.depositDetails != null &&
            Array.isArray(response.offer.paymentPolicy.depositDetails) &&
            response.offer.paymentPolicy.depositDetails.length > 0
          ) {
            let totalPercent = 0;
            const readableEntries: string[] = [];
            for (const depositEntry of response.offer.paymentPolicy
              .depositDetails) {
              totalPercent += depositEntry.percentage;
              readableEntries.push(
                `${depositEntry.percentage}% ${depositEntry.type}`
              );
            }
            response.offer.paymentPolicy.depositDetails.readableData = `${totalPercent}% (${readableEntries.join(
              ', '
            )})`;
          } else {
            response.offer.paymentPolicy.depositDetails = {
              readableData: 'No percentages available',
            };
          }

          /* */
          if (response.booking.autoPayoutDetails != null) {
            for (const payment of response.booking.autoPayoutDetails.payouts) {
              payment.paymentUrl = this.createRevolutPaymentLink(payment);
            }

            if (
              response.booking.autoPayoutDetails
                .partnerReturnTransferPayments != null
            ) {
              for (const payout of response.booking.autoPayoutDetails
                .partnerReturnTransferPayments) {
                payout.paymentUrl = this.createMollieLink(payout.paymentId);
              }
            }
          }

          /* */
          for (const payment of response.booking.paymentStateDetails.payments) {
            /* */
            if (payment.paymentId != null) {
              payment.paymentUrl = this.createMollieLink(payment.paymentId);
            }

            /* */
            if (
              payment.deadlineChanges != null &&
              payment.deadlineChanges.length > 0
            ) {
              let html = `<table><thead><tr><th>ChangedAt</th><th>Old</th><th>New</th></tr></thead><tbody>`;

              for (const deadlineChange of payment.deadlineChanges) {
                html += `<tr><td>${moment
                  .utc(deadlineChange.changedAt)
                  .format('YYYY-MM-DD')}</td><td>${moment
                  .utc(deadlineChange.oldDeadline)
                  .format('YYYY-MM-DD')}</td><td>${moment
                  .utc(deadlineChange.newDeadline)
                  .format('YYYY-MM-DD')}</td>`;
              }

              html += `</tbody></table>`;

              payment.deadlineChangesInHtml = html;
            }
          }

          /* */
          const bookingChangeList: Array<{
            createdAt: string;
            totalBefore: string;
            totalAfter: string;
          }> = [];
          for (const bookingChange of response.bookingLogs) {
            const offerPriceOld = bookingChange.offer.oldValue.price.total;
            const offerPriceNew = bookingChange.offer.newValue.price.total;
            if (offerPriceOld === offerPriceNew) {
              continue;
            }

            bookingChangeList.push({
              createdAt: moment
                .utc(bookingChange.createdAt)
                .format('YYYY-MM-DD'),
              totalBefore: offerPriceOld,
              totalAfter: offerPriceNew,
            });
          }

          /* */
          this.booking = response.booking;
          this.offer = response.offer;
          this.bookingLogs = bookingChangeList;
        },
        (error) => {
          this.eventsService.broadcast(
            'requestShowErrorMessage',
            JSON.stringify(error)
          );
        },
        () => {
          this.loadingIndicatorService.hideLoadingBar();
        }
      );
  }

  toggleRefundApproval(payment: any) {
    const newApprovedState = !payment.refundForPaymentApproved;
    this.loadingIndicatorService.showLoadingBar();
    this.refundApprovalsLoading[payment._id] = true;
    this.http
      .post(
        environment.urls.service +
          `/api/v1/authenticated/admin/booking/payments/${this.bookingId}/payment/${payment._id}/toggle-refund`,
        {
          refundForPaymentApproved: newApprovedState,
        }
      )
      .subscribe(
        () => {
          this.loadingIndicatorService.hideLoadingBar();
          payment.refundForPaymentApproved = newApprovedState;
          delete this.refundApprovalsLoading[payment._id];
        },
        (err) => {
          this.loadingIndicatorService.hideLoadingBar();
          delete this.refundApprovalsLoading[payment._id];
          this.eventsService.broadcast(
            'requestShowErrorMessage',
            JSON.stringify(err)
          );
        }
      );
  }

  public addComment() {
    this.loadingIndicatorService.showLoadingBar();
    this.http
      .post(
        environment.urls.service +
          '/api/v1/authenticated/admin/booking/payments/' +
          this.bookingId +
          '/comment',
        {
          comment: this.formAddComment.get('comment').value,
        }
      )
      .subscribe(
        (response: any) => {
          this.loadBookingPaymentDetails();
          this.resetFormData();
        },
        (error) => {
          this.eventsService.broadcast(
            'requestShowErrorMessage',
            JSON.stringify(error)
          );
        },
        () => {
          this.loadingIndicatorService.hideLoadingBar();
        }
      );
  }

  private resetFormData() {
    this.formAddComment = new FormGroup({
      comment: new FormControl(),
    });
  }

  public showChildModal(): void {
    this.childModal.show();
  }

  public hideChildModal(): void {
    this.childModal.hide();
  }

  public openKitchenWindow(requestId: string) {
    const url = environment.urls.kitchen + '/request/' + requestId + '/offers';
    window.open(url, '_blank');
  }

  public openAdminToolWindow(bookingId: string) {
    const url =
      environment.urls.tool + '//admin/booking/payment-partner?id=' + bookingId;
    window.open(url, '_blank');
  }

  private createMollieLink(paymentId: string) {
    return `https://my.mollie.com/dashboard/org_19125440/payments/${paymentId}`;
  }

  private createRevolutPaymentLink(payment) {
    if (payment.revolutTransactionId != null) {
      return this.createRevolutPaymentTransactionLink(
        payment.revolutTransactionId
      );
    }
    if (payment.revolutPaymentDraftId != null) {
      return this.createRevolutPaymentDraftLink(payment.revolutPaymentDraftId);
    }
    return null;
  }

  private createRevolutPaymentDraftLink(paymentId: string) {
    return `https://business.revolut.com/transfers?tab=draft&type=PAYMENT_DRAFT&id=${paymentId}`;
  }

  private createRevolutPaymentTransactionLink(paymentId: string) {
    if (environment.production === true) {
      return `https://business.revolut.com/transfers?tab=past&type=TRANSACTION&id=${paymentId}`;
    }
    return `https://business.revolut.com/transfers?tab=past&type=TRANSACTION_ITEM&id=${paymentId}`;
  }
}
